import React from 'react';
import { Table } from 'reactstrap';
import {
    Spin,
} from "antd";

export default class MedTable extends React.Component {
    state = {
        loader: false,
        courses: [],
    };

    componentDidMount = () => {
        this.setState({ loader: false });
        fetch(
            "https://sbhs-web-server.herokuapp.com/lte/course/all"
            // "http://localhost:4000/lte/course/all"
        )
            .then((response) => response.json())
            .then((response) => {
                if (response) {
                    const results = response.map((row, index) => ({
                        _id: row._id,
                        key: row._id,
                        rowNumber: index + 1,
                        courseTitle: row.courseTitle,
                        domain: row.domain,
                        courseShortDesc: row.courseShortDesc,
                        courseDesc: row.courseDesc,
                        courseTopics: row.courseTopics,
                        courseThumbnailImageUrl: row.courseThumbnailImageUrl,
                        createdBy: row.createdBy,
                        courseMinutes: row.courseMinutes,
                        createdDate: row.createdDate,
                    }));
                    this.setState({ courses: results, loader: true });
                }
            });
    };




    render() {
        console.log(this.props.selectedRow)
        return (
            <div>
                {!this.state.loader ? (
                    <div>
                        <div className="loadingText"></div>
                        <div className="tc f19 lh-copy">
                            <Spin />
                        </div>
                    </div>
                ) : (<Table dark>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Course Title</th>
                            <th>No. TOpics</th>
                            <th>Domain</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">1</th>
                            <td>Mark</td>
                            <td>Otto</td>
                            <td>@mdo</td>
                        </tr>
                        <tr>
                            <th scope="row">2</th>
                            <td>Jacob</td>
                            <td>Thornton</td>
                            <td>@fat</td>
                        </tr>
                        <tr>
                            <th scope="row">3</th>
                            <td>Larry</td>
                            <td>the Bird</td>
                            <td>@twitter</td>
                        </tr>
                    </tbody>
                </Table >
                    )}
            </div>

        );
    }
}
